export default __webpack_public_path__ + "static/media/courchevel-night-1-721x471.f995ebbb.jpg";